import { render } from "./ConfirmacionMailSection.vue?vue&type=template&id=1632cb26&ts=true"
import script from "./ConfirmacionMailSection.vue?vue&type=script&lang=ts"
export * from "./ConfirmacionMailSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__